<template>
  <div class="min-h-screen bg-gray-50 py-12">
    <div class="container-custom max-w-2xl">
      <div class="card p-8 text-center">
        <!-- Success Icon -->
        <div 
          class="w-20 h-20 rounded-full mx-auto mb-6 flex items-center justify-center"
          :style="{ backgroundColor: companyStore.primaryColor + '20' }"
        >
          <CheckCircleIcon class="h-10 w-10" :style="{ color: companyStore.primaryColor }" />
        </div>
        
        <h1 class="text-3xl font-bold text-gray-900 mb-2">
          {{ $t('order.confirmation.title') }}
        </h1>
        <p class="text-gray-600 mb-6">
          {{ $t('order.confirmation.message') }}
        </p>
        
        <!-- Order Number -->
        <div class="bg-gray-50 rounded-lg p-6 mb-8">
          <p class="text-sm text-gray-500 mb-1">
            {{ $t('order.confirmation.orderNumber') }}
          </p>
          <p class="text-2xl font-bold text-gray-900">{{ orderNumber }}</p>
        </div>
        
        <!-- Actions -->
        <div class="flex flex-col sm:flex-row gap-4 justify-center">
          <router-link
            :to="{ name: 'order-track', query: { number: orderNumber } }"
            class="px-6 py-3 rounded-lg text-white font-medium"
            :style="{ backgroundColor: companyStore.primaryColor }"
          >
            {{ $t('order.confirmation.trackOrder') }}
          </router-link>
          <router-link
            to="/menu"
            class="px-6 py-3 rounded-lg border border-gray-300 font-medium hover:bg-gray-50"
          >
            {{ $t('order.confirmation.newOrder') }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, watch, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { CheckCircleIcon } from '@heroicons/vue/24/outline'
import { useCompanyStore, useCartStore } from '@/stores'

const route = useRoute()
const companyStore = useCompanyStore()
const cartStore = useCartStore()

const orderNumber = computed(() => route.params.orderNumber as string)

// O pedido já foi criado no backend — ao chegar na confirmação (inclusive no
// retorno do checkout do Mercado Pago), o carrinho pode ser esvaziado.
onMounted(() => {
  cartStore.clearCart()
})

// Salva número do pedido no localStorage para acompanhamento
watch(orderNumber, (val) => {
  if (val) {
    localStorage.setItem('lastOrderNumber', val)
    if (companyStore.company?.id) {
      localStorage.setItem('lastOrderCompanyId', String(companyStore.company.id))
    }
  }
}, { immediate: true })
</script>
